import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./auth";

export function ProtectedRoute({ children, allowed }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-slate-500">
        <div className="animate-pulse font-display text-3xl">DiTours</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (allowed && !allowed.includes(user.role)) return <Navigate to="/login" replace />;
  return children;
}
